import { API_TRAIN } from 'apiConfig';
import axios from 'axios';
import qs from 'qs';
Vue.axios = axios;

let api = {
  courses:API_TRAIN.concat("/courses"),    // 培训首页文字培训
  listsInfo:API_TRAIN.concat("/listsInfo"), // 列表页文章列表
  recommonAnalyst:API_TRAIN.concat("/recommonAnalyst"), // 专家专栏
  detailAdList:API_TRAIN.concat("/detailAdList"),    // 详情页广告
  share:API_TRAIN.concat("/share"),  // 详情页分享
  salonAct:API_TRAIN.concat("/salonAct"), // salon互动
  salonQues:API_TRAIN.concat("/salonQues"), // 分析师问答
  question:API_TRAIN.concat("/question"),    // 用户提问
  articleList:API_TRAIN.concat("/articleList"), // 专家专栏
  hotArticle:API_TRAIN.concat("/hotArticle"),   // 资讯24小时热门文章
}
/*
 * 培训首页文字培训
*/
function courses(){
  return axios.post(api.courses, qs.stringify());
}
/*
 * 列表页文章列表
 */
function listsInfo(param){
  return axios.post(api.listsInfo, qs.stringify(param));
}
/*
 * 专业专栏
 */
function recommonAnalyst(){
  return axios.post(api.recommonAnalyst, qs.stringify());
}
/*
 * 详情页广告
 */
function detailAdList(){
  return axios.post(api.detailAdList, qs.stringify());
}
/*
 * 详情页分享统计
 */
function share(param){
  return axios.post(api.share, qs.stringify(param));
}
/*
 * salon互动
 */
function salonAct(){
  return axios.post(api.salonAct, qs.stringify());
}
/*
 * 分析师问答
 */
function salonQues(params){
  return axios.post(api.salonQues, qs.stringify(params));
}

/*
 * 用户提问
 */
function question(param){
  return axios.post(api.question, qs.stringify(param));
}
/*
 * 专家专栏
 */
function articleList(){
  return axios.post(api.articleList, qs.stringify());
}
/*
 * 资讯24小时热门文章
 */
function hotArticle() {
  return axios.post(api.hotArticle, qs.stringify());
}

module.exports = {
  courses:courses,
  listsInfo:listsInfo,
  recommonAnalyst:recommonAnalyst,
  detailAdList:detailAdList,
  share:share,
  salonAct:salonAct,
  salonQues:salonQues,
  question:question,
  articleList:articleList,
  hotArticle:hotArticle,
}



// WEBPACK FOOTER //
// ./src/service/train/train.server.js